/**
* This function replaces the blank spaces of a string with the specified symbol
@param {String} str - String to replace
@param {String} symbol - Symbol
@param {Boolean} lowerCase - Bool to convert str lower case
*/
const replaceSpaceBlank = (str = '', symbol = '-', lowerCase = true) => {
  if (str) {
    if (lowerCase) {
      return str.toLowerCase().replace(/\s+/g, symbol);
    } else {
      return str.replace(/\s+/g, symbol);
    }
  }

  return str
}

/**
* This function add space black to special caracteres
@param {String} string - String to replace
*/
const replaceSignal = (string) => {
  let label = string ? string : '' 
  const arr = ['/','-',',','.','_']
  arr.forEach(x => {
    if (label) {
      if (label.indexOf(x) > 0 && x !== ` ${x} `) {
        label = label.replace(x,`${x} `)
      }
    }
  })

  return string.trim()
}

/**
 * This funcion tranform to UpperCase Firt Letter of a string
 * @param {String} str 
 */
function capitalizarPrimeraLetra(str = '') {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * This funcion split firstName and lastName 
 * @param {String} firstName 
 * @param {String} lastName 
 */
const shortName = (firstName, lastName) => {
  const firstname = firstName ? firstName.split(' ')[0] : ''
  const lastname = lastName ? lastName.split(' ')[0] : ''
  return `${firstname} ${lastname}`
}

export {
  replaceSpaceBlank, replaceSignal, capitalizarPrimeraLetra, shortName
}
